import axios from 'axios'

export const COMPUTERS_HAS_ERROR = 'COMPUTERS_HAS_ERROR'
export const COMPUTERS_IS_LOADING = 'COMPUTERS_IS_LOADING'
export const COMPUTERS_FETCH_DATA_SUCCESS = 'COMPUTERS_FETCH_DATA_SUCCESS'
export const COMPUTERS_CREATE_CACHE = 'COMPUTERS_CREATE_CACHE';

export function computersHasError(err) {
    return {
        type: COMPUTERS_HAS_ERROR,
        error: err
    };
}

export function computersIsLoading(bool) {
    return {
        type: COMPUTERS_IS_LOADING,
        isLoading: bool
    };
}

export function computersFetchDataSuccess(computers) {
    return {
        type: COMPUTERS_FETCH_DATA_SUCCESS,
        computers
    };
}

export function computersCreateCache(computers) {
    var computersCache = computers.reduce(function(hash, value) {
        var key = value['id'];
        hash[key] = value.name;
        return hash;
      }, {});

    return {
        type: COMPUTERS_CREATE_CACHE,
        computersCache
    };
}

async function getData() {
    const res = await axios("/computer?sort=name");
    return res.data;
  }

export function fetchComputers() {
    return (dispatch) => {
        dispatch(computersIsLoading(true));

        getData()
        .then(response => {
            dispatch(computersIsLoading(false));
            dispatch(computersFetchDataSuccess(response));
            dispatch(computersCreateCache(response));
        })
        .catch(err => 
        {
            dispatch(computersHasError(err));
        })
        }
    }

